import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "table table-striped border-light" }
const _hoisted_2 = { colspan: "2" }
const _hoisted_3 = { class: "mb-0 text-center text-capitalize-first" }
const _hoisted_4 = { class: "text-capitalize-first" }
const _hoisted_5 = { class: "text-capitalize-first" }
const _hoisted_6 = { class: "text-capitalize-first" }
const _hoisted_7 = { class: "text-capitalize-first" }
const _hoisted_8 = { class: "text-capitalize-first" }
const _hoisted_9 = { class: "text-capitalize-first" }
const _hoisted_10 = { class: "text-capitalize-first" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 0,
  class: "ms-1"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "text-capitalize-first" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "text-danger" }
const _hoisted_18 = { class: "text-capitalize-first" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "text-capitalize-first" }
const _hoisted_23 = ["href"]
const _hoisted_24 = { key: 1 }
const _hoisted_25 = {
  colspan: "2",
  class: "text-end pt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_copy_button = _resolveComponent("copy-button")!
  const _component_InvoiceRequestsTimelineModal = _resolveComponent("InvoiceRequestsTimelineModal")!
  const _component_WebhookHistoryModal = _resolveComponent("WebhookHistoryModal")!
  const _component_MerchantRequestLogModal = _resolveComponent("MerchantRequestLogModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("table", _hoisted_1, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_2, [
            _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.helper.trans('labels.invoice')), 1)
          ])
        ])
      ]),
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.helper.trans('labels.id')), 1),
          _createElementVNode("td", null, [
            _createTextVNode(_toDisplayString(_ctx.invoice.id) + " ", 1),
            _createVNode(_component_copy_button, {
              value: _ctx.invoice.id
            }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.helper.trans('labels.type')), 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.helper.trans(`direction.${_ctx.invoice.type}`)), 1)
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.helper.trans('labels.date')), 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.dateHelper.format(_ctx.invoice.createdAt)), 1)
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.helper.trans('labels.uid')), 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.invoice.userId), 1)
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.helper.trans('labels.sum')), 1),
          _createElementVNode("td", null, [
            _createElementVNode("span", null, [
              _createTextVNode(_toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.invoice.sum)) + " ", 1),
              _createVNode(_component_copy_button, {
                value: _ctx.numberFormatter.formatNumber(_ctx.invoice.sum)
              }, null, 8, ["value"])
            ])
          ])
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.helper.trans('labels.status')), 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.helper.trans(`invoice_status.${_ctx.invoice.status}`)), 1)
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.helper.trans('labels.paid_sum')), 1),
          (_ctx.invoice.receivedFromMaker && _ctx.invoice.receivedFromTaker)
            ? (_openBlock(), _createElementBlock("td", _hoisted_11, [
                _createTextVNode(_toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.invoice.receivedFromTaker)) + " / " + _toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.invoice.receivedFromMaker)) + " ", 1),
                (_ctx.invoice.rate)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_12, "(" + _toDisplayString(_ctx.helper.trans('labels.rate')) + " " + _toDisplayString(_ctx.invoice.rate) + ")", 1))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("td", _hoisted_13, "n/a"))
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.helper.trans('labels.service_fee')), 1),
          (!_ctx.invoice.serviceFee)
            ? (_openBlock(), _createElementBlock("td", _hoisted_15, "n/a"))
            : (_openBlock(), _createElementBlock("td", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.invoice.serviceFee)), 1)
              ]))
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.helper.trans('labels.payout_sum')), 1),
          (!_ctx.invoice.payoutSum)
            ? (_openBlock(), _createElementBlock("td", _hoisted_19, "n/a"))
            : (_openBlock(), _createElementBlock("td", _hoisted_20, [
                _createElementVNode("span", {
                  class: _normalizeClass({'text-success': _ctx.invoice.type === _ctx.Direction.PAY_IN, 'text-danger': _ctx.invoice.type === _ctx.Direction.PAY_OUT})
                }, _toDisplayString(_ctx.invoice.type === _ctx.Direction.PAY_IN ? '+' : '-') + _toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.invoice.payoutSum)), 3)
              ]))
        ]),
        (_ctx.invoice?.type === _ctx.Direction.PAY_IN)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [
              _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.helper.trans('labels.url')), 1),
              _createElementVNode("td", null, [
                _createElementVNode("a", {
                  href: _ctx.invoice.payUrl,
                  target: "_blank"
                }, _toDisplayString(_ctx.invoice.payUrl), 9, _hoisted_23)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isAdmin)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_24, [
              _createElementVNode("td", _hoisted_25, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showRequestLog && _ctx.showRequestLog(...args))),
                  class: "btn btn-outline-secondary btn-sm text-capitalize-first"
                }, _toDisplayString(_ctx.helper.trans('labels.show_request_log')), 1),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showWebhooksHistory && _ctx.showWebhooksHistory(...args))),
                  class: "btn btn-outline-secondary btn-sm text-capitalize-first ms-1"
                }, _toDisplayString(_ctx.helper.trans('labels.show_webhooks_history')), 1),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showRequestsTimeline && _ctx.showRequestsTimeline(...args))),
                  class: "btn btn-outline-secondary btn-sm text-capitalize-first ms-1"
                }, _toDisplayString(_ctx.helper.trans('labels.show_requests_timeline')), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_InvoiceRequestsTimelineModal, { ref: "invoiceRequestsTimelineModal" }, null, 512),
    _createVNode(_component_WebhookHistoryModal, { ref: "webhookHistoryModal" }, null, 512),
    _createVNode(_component_MerchantRequestLogModal, { ref: "merchantRequestLogModal" }, null, 512)
  ], 64))
}